import * as ArgusUtils from "@mnemonic/pure-utils/ArgusUtils";

import { initializeIntl, initializeSession } from ".";
import initializeLogging from "./initilizeLogging";

export type TUnpacked<T> = T extends (infer U)[]
  ? U
  : T extends (...args: []) => infer U
    ? U
    : T extends Promise<infer U>
      ? U
      : T;

export type TBootstrapReturn = {
  intl: TUnpacked<ReturnType<typeof initializeIntl>>;
  session: TUnpacked<ReturnType<typeof initializeSession>>;
};

export default async function PromiseBootstrap(): Promise<TBootstrapReturn> {
  const target = ArgusUtils.getTargetMeta();
  const session = await initializeSession(target);
  const intl = await initializeIntl(session);
  await initializeLogging(session, target);

  return { session, intl };
}
